import { Http, Vault } from 'lib'
import { sessionManagerState, SessionManagerState } from './store/State'
import {
  reset,
  setIsLoadingCurrentUser,
  setCurrentUser,
  setIsMounted,
  executeLogout,
  SessionManagerAction,
  setCallbackUrl
} from './store/Actions'
import IApiResponse from 'types/IApiResponse'
import IUserData from 'types/sign-in/IUserData'
import apiUrlsAddresses from '../../config/constants/api-urls-addresses'
import ServiceProviderBase from 'lib/ServiceProviderBase'
import sessionManagerReducer from './store/Reducer'
import UserResponsesManager from 'smart-components/user-responses-manager/Service'
import AuthenticationControllerService from 'smart-components/authentication-controller/Service'

class SessionManagerService extends ServiceProviderBase<SessionManagerState, SessionManagerAction> {
  constructor() {
    super(sessionManagerState)
  }

  reduce(state: SessionManagerState, action: SessionManagerAction): SessionManagerState {
    return sessionManagerReducer(state, action)
  }

  setCurrentUser(user: IUserData) {
    this.dispatch(setCurrentUser(user))
  }

  softLogout() {
    this.dispatch(executeLogout())
    Vault.clearAccessToken()
    UserResponsesManager.reset()
  }

  logOff() {
    this.softLogout()
    AuthenticationControllerService.userSignOut()
  }

  async whoAmI() {
    if (this.state.currentUser) {
      return
    }

    this.dispatch(setIsLoadingCurrentUser(true))

    const [response, statusCode, error] = await Http.get<IApiResponse<IUserData>>(apiUrlsAddresses.me.profile())

    if (error) {
      this.logOff()
      if (statusCode !== 401) {
        throw new Error(error)
      }
      return
    }

    this.dispatch(setCurrentUser(response.data))
    this.dispatch(setIsMounted(true))
  }

  setIsMounted(isMounted: boolean) {
    this.dispatch(setIsMounted(isMounted))
  }

  reset() {
    this.dispatch(reset())
  }

  setCallbackUrl() {
    this.dispatch(setCallbackUrl(true))
  }
}

let instance: SessionManagerService = null

export default (() => {
  if (!instance) {
    instance = new SessionManagerService()
  }
  return instance
})()
